import React, { useState, useEffect, useRef } from "react";
import ToggleArrow from '../images/toggle-arrow.png'
import callingAPI from "../service"
import loadingImage from '../images/login-shape.png'
import { useLocation } from "react-router-dom";
import moment from 'moment';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setReportData } from "../redux/reducers/reportSlice";
import Header from "../layout/header";
import HeaderProfile from "../layout/header-profile";
import { setDashboardData } from "../redux/reducers/dashboardSlice";


export default function ActivityReport() {
    const dispatch = useDispatch();
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const [toggleTd, setToggleTd] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    const [toggelTdOne, setToggleTdOne] = useState(1)
    const [cashStatementSummery, setCashStatementSummery] = useState([])
    const [cashStatementDetails, setCashStatementDetails] = useState([])
    const [cashStatementSummeryTotal, setCashStatementSummeryTotal] = useState([])
    const [loaderFlag, setLoaderFlag] = useState(false)
    const refreshToken = dashboardDetails.refreshToken;
    const location = useLocation();

    const prevLocationStateRef = useRef(location.state);
    var userLogId = ""
    const clientId = dashboardDetails.clientid
    const userId = dashboardDetails.userId
    useEffect(() => {
        dispatch(
            setDashboardData({
                moduleId: 7,
                userlogId: ""
            })
        );
        handleUserLog()
        return () => {
            handleUserLog();
        };
    }, []);

    const handleUserLog = () => {
        const postData = {
            "userId": userId,
            "isApp": "false",
            "moduleId": 7,
            "previousPage": dashboardDetails.previousPage,
            "userSession": refreshToken,
            "userLogId": userLogId
        }
        callingAPI(postData, "user/userLog", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    userLogId = data.data.userLogId
                    dispatch(
                        setDashboardData({
                            previousPage: 7,
                        })
                    );
                }
                else {
                    userLogId = ""
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }

    const toggleTableTd = (index) => {
        if (isMobile) {
            setToggleTd(toggleTd === index ? null : index);
        }
    };
    useEffect(() => {
        if (location.state) {
            prevLocationStateRef.current = location.state;
        }
        // setLoaderFlag(true)

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [location.state]);

    useEffect(() => {
        cashSummaryReportList()
    }, [location])

    const cashSummaryReportList = () => {
        const fromDateCashSummary = dashboardDetails.fromDate ? new Date(dashboardDetails.fromDate).toISOString().split('T')[0] : new Date(new Date).toISOString().split('T')[0]
        const toDateCashSummary = dashboardDetails.toDate ? new Date(dashboardDetails.toDate).toISOString().split('T')[0] : new Date(new Date).toISOString().split('T')[0]
        const postData = {
            "userId": userId,
            "fromDate": fromDateCashSummary,
            "toDate": toDateCashSummary,
            "clientId": clientId,
            //"refreshToken": refreshToken
        }
        callingAPI(postData, "reports/cashReport", 'post')
            .then((response) => {
                const { data } = response;
                console.log("🚀 ~ .then ~ data:", data)
                if (data.statusCode === 200) {
                    dispatch(setReportData({
                        cashsummary: data.data
                    }))
                    setCashStatementSummery(data.data.cashStatementSummery.data || []);
                    setCashStatementSummeryTotal(data.data.cashStatementSummery.total || []);
                    setCashStatementDetails(data.data.cashStatementDetails || []);

                    setLoaderFlag(true)
                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    };

    const toggleTableTdOne = (index) => {
        if (isMobile) {
            setToggleTdOne(toggelTdOne === index ? null : index)
        }
    }
    const totalAEDBalance = parseFloat(cashStatementSummeryTotal);

    return (
        <>
            <div className="top-outer">
                <div className="heading-outer">
                    <Header />
                    <HeaderProfile />
                </div>
            </div>
            {loaderFlag ?
                <div className="reports-table">
                    <h3 className="reports-mainHead">Investment Account Activity
                        <span className="date-table-head">({moment(dashboardDetails.reportClickFromDate).format('DD/MM/yyyy')} - {moment(dashboardDetails.reportClickToDate).format('DD/MM/yyyy')})</span>
                    </h3>
                    <div className="row">
                        <div className=" mx-auto col-lg-11">
                            <div className="table-responsive">
                                <table className="table  table-change">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '25%', minWidth: '150px' }}>Currency</th>
                                            <th style={{ width: '10%', minWidth: '100px' }}>Balance</th>
                                            <th style={{ width: '10%', minWidth: '100px' }}>CFD Margin blocked</th>
                                            <th style={{ width: '10%', minWidth: '100px' }}>CFD Loss blocked</th>
                                            <th style={{ width: '10%', minWidth: '100px' }}>Available Balance</th>
                                            <th style={{ width: '10%', minWidth: '100px' }}>FX Rate</th>
                                            <th style={{ width: '10%', minWidth: '100px' }}>Balance (AED)</th>
                                        </tr>
                                    </thead>
                                    {cashStatementSummery?.length > 0 ?
                                        <tbody>
                                            {cashStatementSummery.map((item, index) => (
                                                <tr>
                                                    <td className="td-colors  table-split-head">{item.currency}
                                                        <div className="toggle-table" onClick={() => toggleTableTd(index)}>
                                                            <img src={ToggleArrow} width={12} height={6} alt="toggle" className="img-fluid" />
                                                        </div>
                                                    </td>
                                                    {(isMobile && toggleTd === index) || (!isMobile) ? (
                                                        <>
                                                            <td className="text-end  table-split-div">
                                                                <span className="mobile-td-head">Balance</span>
                                                                <span style={{ color: Number(item.balance) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.balance) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.balance)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.balance) || 0)}
                                                                </span>
                                                            </td>
                                                            <td className="text-end  table-split-div">
                                                                <span className="mobile-td-head">CFD Margin blocked</span>
                                                                <span style={{ color: Number(item.CFDMarginBlocked) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.CFDMarginBlocked) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.CFDMarginBlocked)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.CFDMarginBlocked) || 0)}
                                                                </span>
                                                            </td>
                                                            <td className="text-end  table-split-div">
                                                                <span className="mobile-td-head">CFD Loss blocked</span>
                                                                <span style={{ color: Number(item.CFDLossBlocked) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.CFDLossBlocked) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.CFDLossBlocked)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.CFDLossBlocked) || 0)}
                                                                </span>
                                                            </td>
                                                            <td className="text-end  table-split-div">
                                                                <span className="mobile-td-head">Available Balance</span>
                                                                <span style={{ color: Number(item.AvailableBalance) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.AvailableBalance) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.AvailableBalance)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.AvailableBalance) || 0)}
                                                                </span>
                                                            </td>
                                                            <td className="text-end  table-split-div">
                                                                <span className="mobile-td-head">Fxrate</span>
                                                                <span style={{ color: Number(item.FXRate) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.FXRate) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(item.FXRate)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(item.FXRate) || 0)}
                                                                </span>
                                                            </td>
                                                            <td className="text-end  table-split-div">
                                                                <span className="mobile-td-head">Balance (AED)</span>
                                                                <span style={{ color: Number(item.BalanceInAED) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.BalanceInAED) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.BalanceInAED)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.BalanceInAED) || 0)}
                                                                </span>
                                                            </td>
                                                        </>
                                                    ) : null}
                                                </tr>
                                            ))}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr style={{ textAlign: "center", padding: "30px 0" }}>
                                                <td colSpan="7" style={{ textAlign: "center", padding: "30px 0" }}>
                                                    No Data
                                                </td>
                                            </tr>
                                        </tbody>}
                                    <tfoot>
                                        <tr>
                                            <td className="bg-tr-td  invisible-classes"></td>
                                            <td className="bg-tr-td  invisible-classes"></td>
                                            <td className="bg-tr-td  invisible-classes"></td>
                                            <td className="bg-tr-td  invisible-classes"></td>
                                            <td className="bg-tr-td  invisible-classes"></td>
                                            <td className="tfoot-color bottom-left-radius  invisible-classes">Total</td>
                                            <td className="tfoot-color text-end bottom-right-radius  table-split-div">
                                                <span className="mobile-td-head">Total Balance</span>
                                                <span style={{ color: Number(totalAEDBalance) < 0 ? '#E43740' : 'black' }}>
                                                    {Number(totalAEDBalance) < 0
                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(totalAEDBalance)) || 0)})`
                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(totalAEDBalance) || 0)}
                                                </span>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table  table-change">
                            <thead>
                                <tr>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Tran Date</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Value Date</th>
                                    <th style={{ minWidth: '404px', maxWidth: '404px' }}>Comments</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Debit</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Credit</th>
                                    <th style={{ minWidth: '60px', maxWidth: '60px' }}>Balance</th>
                                </tr>
                            </thead>
                            {cashStatementDetails?.length > 0 ?
                                <tbody>
                                    {cashStatementDetails.map((item, index) => (
                                        <tr>
                                            <td colSpan={6} className="p-0 border-0 td-full">
                                                <table className="table mb-0 table-change">
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={6} className="td-colors bg-white border-0 table-split-head  moble-thead-change">{item.currency}
                                                                <div className="toggle-table"
                                                                    onClick={() => toggleTableTdOne(1)}
                                                                >
                                                                    <img src={ToggleArrow} width={12} height={6} alt="toggle" className="img-fluid" />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody className="striped">
                                                        {(isMobile && toggelTdOne === 1) || (!isMobile) ? (
                                                            <>
                                                                {item.details.map((item, index) => (
                                                                    <tr>
                                                                        <td className="table-split-div " style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                            <span className="mobile-td-head">Tran Date</span>
                                                                            {item.tranDate}</td>
                                                                        <td className="table-split-div  invisible-classes" style={{ minWidth: '60px', maxWidth: '60px' }}>{item.valueDate}</td>
                                                                        <td className="table-split-div  order-3 change_comments" style={{ minWidth: '404px', maxWidth: '404px' }}>
                                                                            <span className="mobile-td-head">Comments</span>
                                                                            {item.comments}</td>
                                                                        <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                            <span className="mobile-td-head">Debit</span>
                                                                            <span style={{ color: Number(item.debit) < 0 ? '#E43740' : 'black' }}>
                                                                                {Number(item.debit) < 0
                                                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.debit)) || 0)})`
                                                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.debit) || 0)}
                                                                            </span>
                                                                        </td>
                                                                        <td className="text-end table-split-div  invisible-classes" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                            <span style={{ color: Number(item.credit) < 0 ? '#E43740' : 'black' }}>
                                                                                {Number(item.credit) < 0
                                                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.credit)) || 0)})`
                                                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.credit) || 0)}
                                                                            </span>
                                                                        </td>
                                                                        <td className="text-end table-split-div  invisible-classes" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                            <span style={{ color: Number(item.balance) < 0 ? '#E43740' : 'black' }}>
                                                                                {Number(item.balance) < 0
                                                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.balance)) || 0)})`
                                                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.balance) || 0)}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </>
                                                        ) : null}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td style={{ minWidth: '60px', maxWidth: '60px' }} className="bg-tr-td  invisible-classes"></td>
                                                            <td style={{ minWidth: '60px', maxWidth: '60px' }} className="bg-tr-td  invisible-classes"></td>
                                                            <td style={{ minWidth: '404px', maxWidth: '404px' }} className="tfoot-color bottom-left-radius  invisible-classes">Total</td>
                                                            <td style={{ minWidth: '60px', maxWidth: '60px' }} className="tfoot-color text-end table-split-div">
                                                                <span className="mobile-td-head">Debit</span>
                                                                <span style={{ color: Number(item.totalDebit) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.totalDebit) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.totalDebit)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.totalDebit) || 0)}
                                                                </span>
                                                            </td>
                                                            <td style={{ minWidth: '60px', maxWidth: '60px' }} className="tfoot-color text-end table-split-div">
                                                                <span className="mobile-td-head">Credit</span>
                                                                <span style={{ color: Number(item.totalCredit) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.totalCredit) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.totalCredit)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.totalCredit) || 0)}
                                                                </span>
                                                            </td>
                                                            <td style={{ minWidth: '60px', maxWidth: '60px' }} className="tfoot-color text-end bottom-right-radius table-split-div">
                                                                <span className="mobile-td-head">Balance</span>
                                                                <span style={{ color: Number(item.totalBalance) < 0 ? '#E43740' : 'black' }}>
                                                                    {Number(item.totalBalance) < 0
                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.totalBalance)) || 0)})`
                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.totalBalance) || 0)}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                :
                                <tbody>
                                    <tr style={{ textAlign: "center", padding: "30px 0" }}>
                                        <td colSpan="6" style={{ textAlign: "center", padding: "30px 0" }}>
                                            No Data
                                        </td>
                                    </tr>
                                </tbody>}
                        </table>
                    </div>
                </div>
                :
                <div className="d-flex justify-content-center align-items-center loading-container">
                    <div className="spinner-container">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <img src={loadingImage} alt="Loading..." className="loading-image" />
                    </div>
                </div>
            }
        </>
    )
}